import { Stack, Title, Text, Button, Alert } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { StandGate } from './StandGate';
import { getStandToken, clearStandToken } from '../../wheel-api/stand';

/**
 * Armado de la tablet de la ruleta. El PIN se pone UNA vez, cuando se montan
 * las tablets, y el token queda guardado en el dispositivo: durante el evento
 * nadie vuelve a ver un PIN.
 *
 * Es lo que habilita el paso de caravana dentro del flujo de la ruleta. Una
 * tablet sin armar sigue sirviendo para girar; simplemente no entrega
 * caravanas, porque el endpoint de entrega pide staff.
 */
export function ArmarTablet() {
  const navigate = useNavigate();

  return (
    <StandGate>
      <Stack align="center" justify="center" style={{ flex: 1 }} gap="lg" px="10%">
        <Title order={2} ta="center" c="forvet.7">TABLET ARMADA</Title>

        <Alert color="blue" radius="md" style={{ maxWidth: 620 }}>
          <Text size="lg">
            Esta tablet ya puede entregar caravanas dentro del flujo de la ruleta.
            No hay que volver a poner el PIN.
          </Text>
        </Alert>

        <Button h={72} w={360} onClick={() => navigate('/kiosk', { replace: true })}>
          VOLVER A LA RULETA
        </Button>

        {getStandToken() && (
          <Button
            variant="subtle" size="sm" c="dimmed"
            onClick={() => { clearStandToken(); navigate('/kiosk', { replace: true }); }}
          >
            Desarmar esta tablet
          </Button>
        )}
      </Stack>
    </StandGate>
  );
}
